import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './App';

/**
 * LoginRoute — wraps pages that require user login (no premium needed).
 * If not logged in, shows a styled prompt to login.
 */
export const LoginRoute = ({ children, pageName }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return (
      <div style={{minHeight:'60vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f0f5e8',padding:'20px'}}>
        <div style={{maxWidth:'400px',width:'100%',background:'#fff',padding:'24px',borderRadius:'12px',
          boxShadow:'0 4px 20px rgba(0,0,0,0.1)',textAlign:'center',border:'3px solid #1b5e20'}}>
          <div style={{fontSize:'2.5rem',marginBottom:'8px'}}>🔐</div>
          <h2 style={{color:'#1b5e20',margin:'0 0 8px 0',fontSize:'1.1rem',fontWeight:900}}>
            உள்நுழைவு தேவை
          </h2>
          <p style={{color:'#555',fontSize:'0.8rem',marginBottom:'12px'}}>
            <b>{pageName || 'இந்தப் பக்கம்'}</b> பார்க்க உள்நுழையவும்
          </p>
          <p style={{color:'#888',fontSize:'0.7rem',marginBottom:'16px'}}>
            Login required to access this page
          </p>
          <a href="/"
            style={{display:'inline-block',background:'linear-gradient(135deg,#1b5e20,#388e3c)',
              color:'#fff',padding:'10px 24px',borderRadius:'8px',textDecoration:'none',
              fontWeight:700,fontSize:'0.85rem'}}>
            🏠 முகப்புக்குச் செல்க — Login
          </a>
        </div>
      </div>
    );
  }

  return children;
};
